import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { MilestoneType } from './enums';

export const MilestoneContainer = styled.div`
    padding: 0 16px;

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0 24px;
    }
`;

export const HeaderContainer = styled.h5`
    display: flex;
    align-items: center;
`;

export const NavLinkContainer = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    flex: 1;
    text-align: right;
    margin-block-start: 1em;
    margin-block-end: 1em;
    padding-top: 5px;

    ${BaseStyle.Mixins.screenSizes.medium} {
        ${BaseStyle.Mixins.fontStyles.ui['14m']};
    }
`;

export const Note = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['14b']};
    padding: 10px 0;
    text-align: center;
`;

export const Section = styled.div<{ $milestoneType?: MilestoneType }>`
    display: flex;
    padding-top: ${({ $milestoneType }) =>
        $milestoneType === MilestoneType.goalieGamesPlayed || $milestoneType === MilestoneType.skaterGamesPlayed
            ? 0
            : '32px'};
`;

export const SectionHeader = styled.h3``;
